import { Page } from '@bounty/creators-design-system'
import { ShopFilters } from './components/ShopFilters'
import { ShopList } from './components/ShopList'
import { ShopListContext } from './components/ShopListContext'
import { useTrackPage } from '../../hooks/useTrackPage'

export type ShopScreenProps = any

export function ShopScreen(props: ShopScreenProps) {
  useTrackPage('Shop List')
  return (
    <Page framed={false} flex={1}>
      <ShopListContext>
        <ShopFilters />
        <ShopList />
      </ShopListContext>
    </Page>
  )
}
